


import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

import ButtonComponent from '@/shared/components/Button.vue';
import SelectOptionsComponent from '@/shared/components/SelectOptions.vue';
import Offerings from '../Offerings.vue';
import InputTextComponent from '@/shared/components/InputText.vue';
import Countries from '../Countries.vue';
import Universities from '../Universities.vue';
import Studies from '../Studies.vue';
import Tooltip from '@/shared/components/Tooltip.vue';

import HttpService from '@/shared/services/http-service';
import StudiesService from '@/shared/services/studies-service';

import { Option, OptionGroup } from '@/shared/models/view/option-viewmodel';
import { IConfig } from '../../models/config-viewmodel';
import { Country } from '@/shared/models/view/country-viewmodel';
import { Offering, Study } from '@/shared/models/view/study-viewmodel';
import { University, ExchangeProgram } from '@/shared/models/view/university-viewmodel';

import studiesData from '../../data/studies';

@Component({
    name: 'StudyInformationView',
    components: {
        ButtonComponent,
        SelectOptionsComponent,
        Offerings,
        InputTextComponent,
        Countries,
        Universities,
        Studies,
        Tooltip
    },
    computed: {
        ...mapState(['preform', 'countries', 'offerings', 'universities', 'config', 'studies']),
        ...mapGetters('root', ['label', 'labelHelp'])
    }
})
export default class StudyInformationViewComponent extends Vue {
    private labelModule = 'SelfServiceRegistration';
    public config!: IConfig;
    private countries!: Country[];
    private offerings!: Offering[];
    private universities!: University[];
    private studies!: Study[];
    private preform!: any;

    get countriesAsOptions(): Option[] {
        return this.countries.map((country: Country) => new Option(country.name, country.isoCode));
    }

    get universitiesAsOptions(): OptionGroup[] {
        return this.universities.map((university: University) => {
            return new OptionGroup(university.name, university.exchangePrograms.map((program: ExchangeProgram) => {
                return new Option(program.description, university.id + '-' + program.id);
            }))  
        });
    }

    get offeringsAsOptions(): Option[] {
        return this.offerings.map((offering: Offering) => {
            return new Option(
                `${+offering.year}/${+offering.year + 1} - ${offering.description}`, 
                `${offering.periodId}-${offering.year}`
            )
        });
    }

    get studiesAsOptions(): Option[] {
        return this.studies.map((study: Study) => new Option(study.description, study.id));
    }

    get chosenSubject(): string {
        if (this.isAdditionalModule()) {
            return this.$store.getters['root/label'](this.labelModule, 'RegistrationType_External');
        }

        let foundStudy = studiesData.find(study => study.value === this.preform.study);
        return foundStudy ? this.$store.getters['root/label'](this.labelModule, foundStudy.name) : '';
    }

    get warningText(): string {
        if (this.isAdditionalModule()) {
            return this.$store.getters['root/label'](this.labelModule, 'selectRegistrationType_Warning_AdditionalModule');
        }
        return this.$store.getters['root/label'](this.labelModule, 'selectRegistrationType_Warning_' + this.preform.study);
    }

    mounted() { 
        this.setStudyId();
    }

    private isAdditionalModule(): boolean {
        if ((this.preform.study === 'Bachelor') ||
            (this.preform.study === 'Master') ||
            (this.preform.study === 'PreMaster') ||
            (this.preform.study === 'AdditionalModule')) {
            return true;
        }

        return false;
    }

    private previousView(): void {
        this.$store.commit('root/clearErrors');
        this.$store.commit('setActiveView', 'StudySelectView');
    }
 
    private nextView(): void {
        this.$store.commit('setActiveView', 'ApplicationFormView');
    }

    private setOfferingValue(value: string): void {
        let offeringSplit = value.split('-');
        this.$store.commit('setPreFormValue', {key: 'period', value: offeringSplit[0]});
        this.$store.commit('setPreFormValue', {key: 'academicYear', value: offeringSplit[1]});
    }

    private setUniversityValue(value: any): void {
        let valueArr = value.split('-');
        let foundUniversity = this.universities.find(university => university.id == valueArr[0]);

        if(foundUniversity) {
            let foundProgram = foundUniversity.exchangePrograms.find(program => program.id === valueArr[1]);
            if (foundProgram) {
                this.setPreFormValue('contractId', foundProgram.id);
                this.setPreFormValue('studyId', foundProgram.programOfStudyId);
                this.setPreFormValue('universityId', foundUniversity.id);
            }
        }
    }

    private setPreFormValue(key: string, value: any): void {
        this.$store.commit('setPreFormValue', {key, value});
    }

    private setStudyId(): void {
        if (this.preform.study === 'PostGraduate' || this.preform.study === 'Exchange') {
            return;
        }
        
        this.$store.commit('setLoading', true);
        let type = this.preform.study === 'SemesterAmsterdam' ? 'SummerInAmsterdam' : 'SecondarySubjects';
        
        Promise.all([
            StudiesService.getStudyIdByType(type, HttpService)
        ])
        .then(values => {
            this.setPreFormValue('studyId', values[0].id);
            this.$store.commit('setLoading', false);
        })
        .catch(error => {
            console.log(error)
            this.$store.commit('root/setErrors', [
                this.config.language === 'nl' ? 
                    'Er gaat iets fout, probeer het later nog een keer' : 
                    'Something went wrong, please try again later'
            ]);
            this.$store.commit('setLoading', false);
        })
    }
}
